$(document).ready(function () {
    //l1
    $('#btnFilter').click(function(e) {
        $('#filtroMobile').addClass('opn-filter');
        e.stopPropagation();
    });
    $('#btnCloseFilter').click(function() {
		$('#filtroMobile').removeClass('opn-filter');
	});
});